var map = {
	"./DNDResized.png": 26,
	"./FoodieFunResized.png": 27,
	"./GigapetResized.png": 28,
	"./RoamlyResized.png": 29,
	"./cornucopia.png": 30,
	"./profile resized.png": 4,
	"./visualResized.png": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;